import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DefaultPage from 'src/pages/backgrounds/default-page';
import { Typography } from '@material-ui/core';
import ProvisioningPage from 'src/pages/driver-page/ProvisioningPage';
import UnProvisioningPage from 'src/pages/driver-page/UnProvisioningPage';
import Administration from 'src/pages/driver-page/Administration';
import ConnectivityPage from 'src/pages/driver-page/ConnectivityPage';
import * as AppSettings from 'src/AppSettings.json';
import { permission } from 'src/auth/permissions';
import { selectUserPermissions, selectUserToken } from 'src/redux/user/user.selectors';
import { connect } from 'react-redux';

const TabPanel = (props) => {
  const { children, userPermissions, userToken, value, index, ...other } = props;
  const values = [permission.Connectivity_Administrator, permission.Connectivity_Reader];
  const matchesPermission = values.some(permission => userPermissions.includes(permission));

/////////////////////////////////// Remove Toggle when deploying Connectivity to Production /////////////////////// 

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {
        matchesPermission ?
          <>
            {value === index && value === 0 && (
              AppSettings.config["environment"] === "production" ? <DefaultPage backgroundtype='true' /> : <ProvisioningPage />
            )}
            {value === index && value === 1 && (
              AppSettings.config["environment"] === "production" ? <DefaultPage backgroundtype='true' /> : <UnProvisioningPage />
            )}
            {value === index && value === 2 && (
              AppSettings.config["environment"] === "production" ? <DefaultPage backgroundtype='true' /> : <ConnectivityPage />
            )}
            {value === index && value === 3 && (
              AppSettings.config["environment"] === "production" ? <DefaultPage backgroundtype='true' /> : <Administration />
            )}
          </>
          :
          <>
            {value === index && value === 0 && (
              <DefaultPage />
            )}
            {value === index && value === 1 && (
              <DefaultPage />
            )}
            {value === index && value === 2 && (
              <DefaultPage />
            )}
            {value === index && value === 3 && (
              <DefaultPage />
            )}
          </>
      }
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 2,
    margin: -theme.spacing(2.9),
    height: '55px',
    marginLeft: '115px'
  },
  panel: {
    marginLeft: '35px',
    position: "fixed",
    height: "100%",
    width: "100%",
    display: "block",
    top: "0",
    left: "0",
    padding: "55px",
    backgroundImage: 'linear-gradient(60deg, rgba(13,13,13,1), rgba(37,37,37,1) 99%)',
  },
  tabBar: {
    marginRight: theme.spacing(-22),
    marginLeft: theme.spacing(22.5),
    textTransform: 'initial',
    fontSize: '15px',

  },
  appBar: {
    backgroundColor: "#131313",
    position: 'fixed',
    marginTop: '-100px',
    marginLeft: '-180px',
    zIndex: '20',
    height: '48px',
    boxShadow: '0 5px 6px #000000'
  }
}));

const StyledTabs = withStyles({
  indicator: {
    backgroundColor: '#1EF1C6',
    height: '3px',
    maxWidth: '110px',
    marginLeft: '25px'
  }
})(Tabs);

const ConnectivityTabs = (props) => {
  const { userPermissions, userToken } = props

  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Typography style={{ textAlign: 'center', fontSize: '15px', marginTop: '15px', marginLeft: '35px', fontFamily: "LynkcoTypeRegular", cursor: 'pointer', color: 'white', alignItems: 'center', justifyContent: 'center', position: 'absolute', display: 'flex', letterSpacing: '2px' }} variant="h4" id="tableTitle" component="div">
          CONNECTIVITY
        </Typography>
        <StyledTabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab label="Provisioning" {...a11yProps(0)} className={classes.tabBar} />
          <Tab label="Unprovisioning" {...a11yProps(1)} className={classes.tabBar} />
          <Tab label="Who's Connected" {...a11yProps(2)} className={classes.tabBar} />
          <Tab label="Administration" {...a11yProps(3)} className={classes.tabBar} />
        </StyledTabs>
      </AppBar>
      <TabPanel
        value={value}
        index={0}
        className={classes.panel}
        userPermissions={userPermissions}
        userToken={userToken}
      >
        PROVISIONING
      </TabPanel>
      <TabPanel
        value={value}
        index={1}
        className={classes.panel}
        userPermissions={userPermissions}
        userToken={userToken}
      >
        UNPROVISIONING
      </TabPanel>
      <TabPanel
        value={value}
        index={3}
        className={classes.panel}
        userPermissions={userPermissions}
        userToken={userToken}
      >
        WHO'S CONNECTED
      </TabPanel>
      <TabPanel
        value={value}
        index={2}
        className={classes.panel}
        userPermissions={userPermissions}
        userToken={userToken}
      >
        ADMINISTRATION
      </TabPanel>
    </div>
  );
};

const mapStateToProps = state => ({
  userPermissions: selectUserPermissions(state),
  userToken: selectUserToken(state)
});

export default connect(mapStateToProps, null)(ConnectivityTabs);